import React from 'react'
import { StaticQuery, graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import Siema from 'siema'
import IconStar from '../icons/star.svg'
import IconUser from '../icons/user.svg'
import IconArrowLeft from '../icons/arrow-left.svg'
import IconArrowRight from '../icons/arrow-right.svg'
import kebabCase from '../utils/kebabCase'

const Slider = ({ data }) => {
	// do smthn
	const slid = React.useRef()
	const nxtBut = React.useRef()
	const prvBut = React.useRef()
	React.useLayoutEffect(() => {
		const mySiema = new Siema({
			selector: slid.current,
			duration: 500,
			easing: 'ease-in-out',
			loop: true,
			rtl: false,
			onInit: () => {},
			onChange: () => {},
		})
		setInterval(() => mySiema.next(), 5000)
		prvBut.current.addEventListener('click', () => mySiema.prev())
		nxtBut.current.addEventListener('click', () => mySiema.next())

		return () => {}
	}, [])
	return (
		<div className="featured-slider-wrap visible animate fade-in">
			<div className="featured-slider visible" ref={slid}>
				{data.allMarkdownRemark.edges.map(({ node }) => (
					<article
						className={`post-wrap visible d-flex flex-row-reverse ${
							node.frontmatter.thumbnail !== `` ? `` : `no-image`
						}`}
						key={node.fields.slug}
					>
						{node.frontmatter.thumbnail && (
							<Link
								to={node.fields.slug}
								className="featured-image-wrap"
								aria-label="Featured image"
							>
								<div
									className="featured-image"
									style={{
										backgroundImage: `url(${node.frontmatter.thumbnail.childImageSharp.fluid.src})`,
									}}
								/>
							</Link>
						)}
						<div className="post-info">
							{node.frontmatter.featured && (
								<span className="featured-label">
									<IconStar />
								</span>
							)}
							{node.frontmatter.tags && (
								<Link
									className="tag d-inline-flex"
									to={`/tags/${kebabCase(node.frontmatter.tags[0])}`}
								>
									{node.frontmatter.tags[0]}
								</Link>
							)}
							<span className="reading-time">{node.timeToRead} min read</span>
							<span className="date">{node.frontmatter.date}</span>
							<h2 className="title">
								<Link to={node.fields.slug}>{node.frontmatter.title}</Link>
							</h2>
							<div className="author d-flex flex-row align-items-center">
								<Link to={node.fields.slug}>
									{data.avatar ? (
										<Img
											fixed={data.avatar.childImageSharp.fixed}
											alt="avatar"
											className="avatar"
										/>
									) : (
										<div className="avatar no-image">
											<IconUser />
										</div>
									)}
								</Link>
								<div className="author-inner">
									<span className="name">
										<Link to={node.fields.slug}>{`Imed Adel`}</Link>
									</span>
								</div>
							</div>
						</div>
					</article>
				))}
			</div>
			<div className="prev" ref={prvBut}>
				<IconArrowLeft />
			</div>
			<div className="next" ref={nxtBut}>
				<IconArrowRight />
			</div>
		</div>
	)
}

const indexQuery = graphql`
	query {
		site {
			siteMetadata {
				title
				siteUrl
			}
		}
		avatar: file(absolutePath: { regex: "/profile-pic./" }) {
			childImageSharp {
				fixed(width: 40, height: 40) {
					...GatsbyImageSharpFixed
				}
			}
		}
		allMarkdownRemark(
			sort: { fields: [frontmatter___date], order: DESC }
			limit: 5
			filter: { frontmatter: { featured: { eq: true } } }
		) {
			edges {
				node {
					excerpt
					fields {
						slug
					}
					timeToRead
					frontmatter {
						date(formatString: "MMMM DD, YYYY")
						title
						tags
						description
						featured
						thumbnail {
							childImageSharp {
								fluid(maxWidth: 640) {
									...GatsbyImageSharpFluid
								}
							}
						}
					}
				}
			}
		}
	}
`

export default () => (
	<StaticQuery query={indexQuery} render={data => <Slider data={data} />} />
)
